<template>
  <div
    :class="[
      'play-by-play-tennis-action',
      { 'play-by-play-tennis-action--is-new': isNew }
    ]"
  >
    <div class="play-by-play-tennis-action__timestamp">
      {{ formatSet(action.set) }} • G{{ action.game }}
    </div>
    <div
      v-if="action.homeScore !== 'GAME_WON' && action.homeScore !== 'GAME_LOST'"
      class="play-by-play-tennis-action__message"
    >
      <span :class="{'point-won': action.pointWon === 'HOME'}">{{ action.homeScore }}</span> :
      <span :class="{'point-won': action.pointWon === 'AWAY'}">{{ action.awayScore }}</span>
    </div>
    <div
      class="play-by-play-tennis-action__message"
      v-else
    >
      {{ action.homeScore === 'GAME_WON' ? homeTeam.name : awayTeam.name }} won game {{ action.game }}
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import Tennis from '@/services/helpers/tennis';

export default {
  props: {
    action: {
      type: Object,
      required: true,
    },
    homeTeam: {
      type: Object,
      required: true,
    },
    awayTeam: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const timeoutId = ref(null);
    const isNew = ref(true);

    const formatSet = (set) => Tennis.PeriodLabels[set] || set;

    onMounted(() => {
      timeoutId.value = setTimeout(() => {
        isNew.value = false;
        clearTimeout(timeoutId.value);
        timeoutId.value = null;
      }, 2000);
    });
    onUnmounted(() => {
      if (!timeoutId.value) return;
      clearTimeout(timeoutId.value);
      timeoutId.value = null;
    });

    return {
      isNew,
      formatSet,
    };
  },
};
</script>

<style lang="scss">
.play-by-play-tennis-action {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  border-radius: var(--radius-none, 0px);
  border-bottom: 1px solid var(--neutral-stroke-default-resting, #F0F0F0);
  height: 48px;
  min-height: var(--width-medium, 32px);
  padding: var(--spacing-xxsmall, 4px) var(--spacing-medium, 16px);
  gap: var(--spacing-xsmall, 8px);
  flex-shrink: 0;
  align-self: stretch;

  &:last-of-type {
    border-bottom: none;
  }

  &--is-new {
    background: var(--neutral-bg-default-hover, #FAFAFA);
  }

  &__message {
    color: var(--neutral-text-default-resting, #191414);
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    .point-won {
      color: #00BC57;
    }
  }

  &__timestamp {
    color: var(--neutral-text-weak-hover, #A9A9A9);
    font-family: Rubik;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
  }
}
</style>
